import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Globals } from '../../globals';
import { FlexibilitySettings } from '../../interfaces';

@Injectable({
  providedIn: 'root',
})
export class FlexibilitySettingsService {
  private readonly client = inject(HttpClient);
  private readonly globals = inject(Globals);

  getByInstallationId(installationId: number): Observable<FlexibilitySettings> {
    const url = `${this.globals.apiRoot}/JwtFlexibility/installation/${installationId}`;
    return this.client.get<FlexibilitySettings>(url);
  }

  createOrUpdate(settings: FlexibilitySettings): Observable<void> {
    const url = `${this.globals.apiRoot}/JwtFlexibility`;
    return this.client.post<void>(url, settings);
  }
}
